import { OnBoardingActionTypes } from './actions';
import Constants from './constants';

const ACTION_HANDLERS = {
  [OnBoardingActionTypes.UPDATE_ONBOARDING_USER]: (state, action) =>
    Object.assign({}, state, {
      onboardingUser: {
        ...action.payload.onboardingUser,
      },
    }),
  [OnBoardingActionTypes.FETCH_ORG_ADDRESS_TAX_RATE_WAITING]: state => {
    return Object.assign({}, state, {
      isFetchingOrgTaxRate: true,
      taxData: null,
    });
  },
  [OnBoardingActionTypes.FETCH_ORG_ADDRESS_TAX_RATE_COMPLETED]: (state, action) => {
    return Object.assign({}, state, {
      isFetchingOrgTaxRate: false,
      taxData: action.payload.taxDetails,
    });
  },

  [OnBoardingActionTypes.FETCH_ORG_ADDRESS_TAX_RATE_FAILED]: (state, action) =>
    Object.assign({}, state, {
      isFetchingOrgTaxRate: false,
      taxData: null,
    }),
  [OnBoardingActionTypes.FETCH_PRICE_WAITING]: state => {
    return Object.assign({}, state, {
      isFetchingPrice: true,
    });
  },
  [OnBoardingActionTypes.FETCH_PRICE_COMPLETED]: (state, action) => {
    return Object.assign({}, state, {
      isFetchingPrice: false,
      priceData: action.payload.priceDetails,
    });
  },

  [OnBoardingActionTypes.FETCH_PRICE_FAILED]: (state, action) =>
    Object.assign({}, state, {
      isFetchingPrice: false,
      priceData: null,
    }),
  [OnBoardingActionTypes.FETCH_RENEWAL_PRICE_WAITING]: state => {
    return Object.assign({}, state, {
      isFetchingPrice: true,
    });
  },
  [OnBoardingActionTypes.FETCH_RENEWAL_PRICE_COMPLETED]: (state, action) => {
    return Object.assign({}, state, {
      isFetchingPrice: false,
      renewalPriceData: action.payload.priceDetails,
    });
  },
  [OnBoardingActionTypes.FETCH_RENEWAL_PRICE_FAILED]: (state, action) =>
    Object.assign({}, state, {
      isFetchingPrice: false,
      renewalPriceData: null,
    }),
  [OnBoardingActionTypes.UPDATE_ORG_FORM_ADDRESS]: (state, action) =>
    Object.assign({}, state, {
      organizationFormDetails: {
        address: action.payload.address,
        city: action.payload.city,
        country_code: action.payload.country,
        state: action.payload.stateVal,
        postal_code: action.payload.postalCode,
      },
    }),

  [OnBoardingActionTypes.FETCH_SUBSCRIPTION_COMPLETED]: (state, action) =>
    Object.assign({}, state, {
      isFetchingSubscriptions: false,
      subscriptions: action.payload.subscriptions.results,
    }),
  [OnBoardingActionTypes.FETCH_SUBSCRIPTIONS_WAITING]: state =>
    Object.assign({}, state, {
      isFetchingSubscriptions: true,
    }),
  [OnBoardingActionTypes.FETCH_SUBSCRIPTIONS_FAILED]: (state, action) =>
    Object.assign({}, state, {
      isFetchingSubscriptions: false,
      subscriptionFetchingStatus: action.payload.status || '',
    }),

  //   [CLEAN_STATUS]: state => Object.assign({}, state, { status: null }), //FIXME: Why needed?
  [OnBoardingActionTypes.SUBSCRIPTION_RENEWAL_CHANGE]: (state, action) =>
    Object.assign({}, state, {
      subscriptionRenewal: action.payload.subscriptionRenewal,
    }),
  [OnBoardingActionTypes.SUBSCRIPTION_TYPE_CHANGE]: (state, action) =>
    Object.assign({}, state, { subscriptionType: action.payload.subscriptionType.toString() }),
  [OnBoardingActionTypes.SUBSCRIPTION_QUANTITY_CHANGE]: (state, action) =>
    Object.assign({}, state, { subscriptionQuantity: parseInt(action.payload.subscriptionQuantity | 0, 10) }),
  [OnBoardingActionTypes.SUBSCRIPTION_PERIOD_CHANGE]: (state, action) =>
    Object.assign({}, state, { subscriptionPeriod: parseInt(action.payload.subscriptionPeriod || 12, 10) }),
  [OnBoardingActionTypes.CREATE_ACCOUNT_COMPLETED]: (state, action) =>
    Object.assign({}, state, {
      isFetching: false,
      status: null,
      onboardingUser: {
        ...action.payload.onboardingUser,
      },
    }),
  [OnBoardingActionTypes.CREATE_ACCOUNT_FAILED]: (state, action) =>
    Object.assign({}, state, {
      isFetching: false,
      status: action.payload.status,
    }),
  [OnBoardingActionTypes.CREATE_ACCOUNT_WAITING]: (state, action) =>
    Object.assign({}, state, {
      isFetching: true,
      status: action.payload.status,
    }),

  [OnBoardingActionTypes.CREATE_SUBSCRIPTION_COMPLETED]: (state, action) =>
    Object.assign({}, state, {
      isPurchaseCompleted: true,
      isFetching: false,
      status: null,
      subscriptions: [...state.subscriptions, ...action.payload.subscriptions],
    }),
  [OnBoardingActionTypes.CREATE_SUBSCRIPTION_FAILED]: (state, action) =>
    Object.assign({}, state, {
      isFetching: false,
      status: action.payload.status,
    }),
  [OnBoardingActionTypes.CREATE_SUBSCRIPTION_WAITING]: (state, action) =>
    Object.assign({}, state, {
      isFetching: true,
      status: action.payload.status,
    }),

  [OnBoardingActionTypes.CREATE_SEATS_COMPLETED]: (state, action) => {
    const { isUpgrading, seats } = action.payload;
    const subs = isUpgrading ? seats : [...state.subscriptions, ...action.payload.seats];
    return Object.assign({}, state, {
      isPurchaseCompleted: true,
      isFetching: false,
      status: null,
      subscriptions: subs,
    });
  },
  [OnBoardingActionTypes.CREATE_SEATS_FAILED]: (state, action) =>
    Object.assign({}, state, {
      isFetching: false,
      status: action.payload.status,
    }),
  [OnBoardingActionTypes.CREATE_SEATS_WAITING]: (state, action) =>
    Object.assign({}, state, {
      isFetching: true,
      status: action.payload.status,
    }),

  [OnBoardingActionTypes.SEND_REQUEST_DEMO_COMPLETED]: state =>
    Object.assign({}, state, {
      isFetching: false,
      status: null,
      demoCompleted: true,
    }),
  [OnBoardingActionTypes.SEND_REQUEST_DEMO_FAILED]: (state, action) =>
    Object.assign({}, state, {
      isFetching: false,
      status: action.payload.status,
    }),
  [OnBoardingActionTypes.SEND_REQUEST_DEMO_WAITING]: (state, action) =>
    Object.assign({}, state, {
      isFetching: true,
      status: action.payload.status,
    }),
};

export function onboardingReducer(
  state = {
    onboardingUser: window.___INITIAL_STATE__.onboardingUser || null,

    subscriptionType: '3',
    subscriptionRenewal: 'YEAR',
    subscriptionQuantity: 1,
    subscriptionPeriod: 12,

    subscriptions: [],
    subscriptionFetchingStatus: null,
    isFetchingSubscriptions: false,
    isPurchaseCompleted: false,

    status: '',
    isFetching: false,

    modal: window.location.search.indexOf('show') !== -1,
    show: false,
    demoCompleted: false,

    isFetchingOrgTaxRate: false,
    isFetchingPrice: false,
    organizationFormDetails: {},
    taxData: null,
    priceData: null,
    renewalPriceData: null,
  },
  action,
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

export default {
  name: Constants.MODULE_NAME,
  reducer: onboardingReducer,
};
